import {analytics, rc} from "../firebase"
import * as libphonenumber from "libphonenumber-js"
import {toast} from "react-hot-toast";
import {getValue} from 'firebase/remote-config';
import {useCallback, useRef} from 'react';

export const DEV = true;

let navigator = window.navigator;
navigator.getUserMedia = (
    navigator.getUserMedia ||
    navigator.webkitGetUserMedia ||
    navigator.mozGetUserMedia ||
    navigator.msGetUserMedia
);

export let OSName = "Unknown OS";
if (navigator.appVersion.indexOf("Win") !== -1)
    OSName = "Windows";
if (navigator.appVersion.indexOf("Mac") !== -1)
    OSName = "MacOS";
if (navigator.appVersion.indexOf("X11") !== -1)
    OSName = "UNIX";
if (navigator.appVersion.indexOf("Linux") !== -1)
    OSName = "Linux";

let nAgt = navigator.userAgent;
export let browserName = navigator.appName;
let fullVersion = '' + parseFloat(navigator.appVersion);
let majorVersion;
let nameOffset, verOffset, ix;

// In Opera, the true version is after "Opera" or after "Version"
if ((verOffset = nAgt.indexOf("Opera")) !== -1) {
    browserName = "Opera";
    fullVersion = nAgt.substring(verOffset + 6);
    if ((verOffset = nAgt.indexOf("Version")) !== -1)
        fullVersion = nAgt.substring(verOffset + 8);
}
// In MSIE, the true version is after "MSIE" in userAgent
else if ((verOffset = nAgt.indexOf("MSIE")) !== -1) {
    browserName = "IE";
    fullVersion = nAgt.substring(verOffset + 5);
}
// In Chrome, the true version is after "Chrome"
else if ((verOffset = nAgt.indexOf("Chrome")) !== -1) {
    browserName = "Chrome";
    fullVersion = nAgt.substring(verOffset + 7);
}
// In Safari, the true version is after "Safari" or after "Version"
else if ((verOffset = nAgt.indexOf("Safari")) !== -1) {
    browserName = "Safari";
    fullVersion = nAgt.substring(verOffset + 7);
    if ((verOffset = nAgt.indexOf("Version")) !== -1)
        fullVersion = nAgt.substring(verOffset + 8);
}
// In Firefox, the true version is after "Firefox"
else if ((verOffset = nAgt.indexOf("Firefox")) !== -1) {
    browserName = "Firefox";
    fullVersion = nAgt.substring(verOffset + 8);
}
// In most other browsers, "name/version" is at the end of userAgent
else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) <
    (verOffset = nAgt.lastIndexOf('/'))) {
    browserName = nAgt.substring(nameOffset, verOffset);
    fullVersion = nAgt.substring(verOffset + 1);
    if (browserName.toLowerCase() === browserName.toUpperCase()) {
        browserName = navigator.appName;
    }
}
// trim the fullVersion string at semicolon/space if present
if ((ix = fullVersion.indexOf(";")) !== -1)
    fullVersion = fullVersion.substring(0, ix);
if ((ix = fullVersion.indexOf(" ")) !== -1)
    fullVersion = fullVersion.substring(0, ix);

majorVersion = parseInt('' + fullVersion, 10);
if (isNaN(majorVersion)) {
    fullVersion = '' + parseFloat(navigator.appVersion);
    majorVersion = parseInt(navigator.appVersion, 10);
}

export function mobileCheck() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series([46])0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br([ev])w|bumb|bw-([nu])|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do([cp])o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly([-_])|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-([mpt])|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c([- _agpst])|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac([ \-/])|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja([tv])a|jbro|jemu|jigs|kddi|keji|kgt([ /])|klon|kpt |kwc-|kyo([ck])|le(no|xi)|lg( g|\/([klu])|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t([- ov])|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30([02])|n50([025])|n7(0([01])|10)|ne(([cm])-|on|tf|wf|wg|wt)|nok([6i])|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan([adt])|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c([-01])|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel([im])|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
}

// Opera 8.0+
export const isOpera = (!!window.opr && !!window.opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

// Firefox 1.0+
export const  isFirefox = typeof InstallTrigger !== 'undefined';

// Safari 3.0+ "[object HTMLElementConstructor]"
export const  isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof window.safari !== 'undefined' && window.safari.pushNotification));

// Internet Explorer 6-11
export const  isIE = /*@cc_on!@*/false || !!document.documentMode;

// Edge 20+
export const  isEdge = !isIE && !!window.StyleMedia;

// Chrome 1 - 79
export const  isChrome = !!window.chrome;

// Edge (based on chromium) detection
export const  isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") !== -1);

export function log() {
    if (console) {
        console.debug(new Date());
        for (let i in arguments) {
            console.debug(arguments[i]);
        }
    }
}

/**
 * Log Firebase event
 *
 * @param event event name
 * @param params object Ex: { type: 'level_up'}
 */
export function logEvent(event, params){
   analytics.logEvent(event, params);
}

export function recordAnalyticsEvent(category, action, label, value) {
    if (DEV) {
        log('google analytics event ' + category + ", " + action + ", " + label + "," + value);
        return;
    }
    try {
        console.debug("ADD GOOGLE ANALITICS");
        //ga('send', 'event', category, action, label, value);
    } catch (e) {
        log('google analytics event with value error');
        log(e);
    }
}

export function popupNotification(title, text, tag){
    try {
        let notification = new Notification(title, {
            icon: '/images/call_assistant.png',
            body: text,
            tag: tag,

        });
        // notification.onclick = function() {
        // };
    }catch (e) {
        log('Error ' + e.message, e);
    }
}

function _base64ToArrayBuffer(base64) {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes;
}

export function replaceAll(string, search, replace) {
    return string.split(search).join(replace);
}

// Cookies
export function createCookie(name, value, days) {
    let expires = "";
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    }

    document.cookie = name + "=" + value + expires + "; path=/";
}

export function readCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

export function eraseCookie(name) {
    createCookie(name, "", -1);
}


function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
}

export function guid() {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
}

export function isMobileNumber(number, country) {
    try {
        debugger;
        const n = libphonenumber.parsePhoneNumber(number, country || "US");
        const type = n.getType();
        const result = !type || type === "MOBILE";
        console.debug(number + 'is mobile: ' + result)
        return result;
    }catch (e) {
        log("Error " + e.message, e);
        return false
    }
}

export function hasVoipNumber(sessionInfo){
    if (!sessionInfo) {
        return false;
    }
    for (let i in sessionInfo.verified_numbers) {
        const n = sessionInfo.verified_numbers[i];
        if (n.voip) {
            return true;
        }
    }
    return false;
}


export function canSendSMS(number, country) {
    try {
        if (!hasVoipNumber()) {
            return false;
        }
        const type = libphonenumber.parsePhoneNumber(number, country || "US");
        return type.getType() === "MOBILE" || type.getType() === "FIXED_LINE_OR_MOBILE" || type.getType() === "VOIP";
    }catch (e) {
        log("Error " + e.message, e);
        return false
    }
}

export function canCallVideo(number, country) {
    try {
        const type = libphonenumber.parsePhoneNumber(number, country || "US");
        return type.getType() === "MOBILE" || type.getType() === "FIXED_LINE_OR_MOBILE" || type.getType() === "VOIP";
    }catch (e) {
        log("Error " + e.message, e);
        return false
    }
}

export function getClientId() {
    let id = readCookie('client_id');
    if (id == null) {
        id = guid();
        createCookie('client_id', id);
    }
    return id;
}

export function extractNumber(sip) {
    let number = sip;
    if (number.indexOf("sip") >= 0) { // extract number from SIP address
        const at = number.indexOf("@");
        number = number.slice(4, at);
        if (number[0] !== '+') {
            number = "+" + number;
        }
    }
    return number;

}

export function getNationalNumber(number, country) {
    if (number) {
        try {
            let phoneNumber = libphonenumber.parsePhoneNumberFromString(number, country || true);
            number = phoneNumber.format("NATIONAL");
        } catch (e) {
            log("getInternationalNumber error", e);
        }
    }
    return number
}

export function hasUser(type, sessionInfo) {
    for (let i in sessionInfo.users) {
        let u = sessionInfo.users[i];
        if (u.type === type) {
            return true;
        }
    }
    return false;
}

export function getInternationalNumber(number, country) {
    if (number) {
        try {
            let phoneNumber = libphonenumber.parsePhoneNumberFromString(number, country || "US");
            number = phoneNumber.format("INTERNATIONAL");
        } catch (e) {
            log("getInternationalNumber error", e);
        }
    }
    return number
}

export function getE164Number(number, country) {
    if (number) {
        try {
            let phoneNumber = libphonenumber.parsePhoneNumberFromString(number, country || "US");
            number = phoneNumber.format("E.164");
        } catch (e) {
            log("getInternationalNumber error", e);
        }
    }
    return number
}

export function isValidNumber(number, country) {
    try {
        let phoneNumber = libphonenumber.parsePhoneNumberFromString(number, country || "US");
        return phoneNumber.isValid();
    }catch (e) {
        log("getInternationalNumber error", e);
    }
    return false;
}

export const MONTH_NAMES = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
];


export function getFormattedDate(date, prefomattedDate = false, hideYear = false) {
    const day = date.getDate();
    const month = MONTH_NAMES[date.getMonth()];
    const year = date.getFullYear();
    const hours = date.getHours();
    let minutes = date.getMinutes();

    if (minutes < 10) {
        // Adding leading zero to minutes
        minutes = `0${ minutes }`;
    }

    if (prefomattedDate) {
        // Today at 10:20
        // Yesterday at 10:20
        return `${ prefomattedDate } at ${ hours }:${ minutes }`;
    }

    if (hideYear) {
        // 10. January at 10:20
        return `${ day }. ${ month } at ${ hours }:${ minutes }`;
    }

    // 10. January 2017. at 10:20
    return `${ day }. ${ month } ${ year }. at ${ hours }:${ minutes }`;
}


// --- Main function
export function timeAgo(dateParam) {
    if (!dateParam) {
        return null;
    }

    const date = typeof dateParam === 'object' ? dateParam : new Date(dateParam);
    const DAY_IN_MS = 86400000; // 24 * 60 * 60 * 1000
    const today = new Date();
    const yesterday = new Date(today - DAY_IN_MS);
    const seconds = Math.round((today - date) / 1000);
    const minutes = Math.round(seconds / 60);
    const isToday = today.toDateString() === date.toDateString();
    const isYesterday = yesterday.toDateString() === date.toDateString();
    const isThisYear = today.getFullYear() === date.getFullYear();


    if (seconds < 5) {
        return 'now';
    } else if (seconds < 60) {
        return `${ seconds } seconds ago`;
    } else if (seconds < 90) {
        return 'about a minute ago';
    } else if (minutes < 60) {
        return `${ minutes } minutes ago`;
    } else if (isToday) {
        return getFormattedDate(date, 'Today'); // Today at 10:20
    } else if (isYesterday) {
        return getFormattedDate(date, 'Yesterday'); // Yesterday at 10:20
    } else if (isThisYear) {
        return getFormattedDate(date, false, true); // 10. January at 10:20
    }

    return getFormattedDate(date); // 10. January 2017. at 10:20
}

export const cyrb53 = function(str, seed = 0) {
    let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
    for (let i = 0, ch; i < str.length; i++) {
        ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ (h1>>>16), 2246822507) ^ Math.imul(h2 ^ (h2>>>13), 3266489909);
    h2 = Math.imul(h2 ^ (h2>>>16), 2246822507) ^ Math.imul(h1 ^ (h1>>>13), 3266489909);
    return 4294967296 * (2097151 & h2) + (h1>>>0);
};

/**
 * Simulate screener sequence
 */
export function testScreener(from) {
    //showIncomingCall('name', from);
    emulateMessage({"call_action":"screen","action":"call_action","from": from ,"id":"49a81cfd-2326-5cc3-6213-b391b8f1ff62","text":"Hi, Paulo can't take your call, how can I help? ","lang":"en-US","call_id":"CA2844dd34a2729347dc6b16f72041e9e4"}, 1000);
    emulateMessage({"screener_id":"8eab1528-5e99-462e-ab84-fed6bdcb249d","partial":true,"action":"screener","from":from,"text":"Hi"}, 2000);
    emulateMessage({"screener_id":"8eab1528-5e99-462e-ab84-fed6bdcb249d","partial":true,"action":"screener","from":from,"text":"Hi hello"}, 3000);
    emulateMessage({"screener_id":"8eab1528-5e99-462e-ab84-fed6bdcb249a","partial":true,"action":"screener","from":from,"text":"Hi hello, this is a test"}, 4000);
    emulateMessage({"screener_id":"8eab1528-5e99-462e-ab84-fed6bdcb249q","partial":true,"action":"screener","from":from,"text":"Hello this is a test"}, 5000);
    emulateMessage({"screener_id":"8eab1528-5e99-462e-ab84-fed6bdcb2422","partial":false, "action":"screener","from":from,"text":"Hi How are you?"}, 7000);
}

/**
 * Incoming call
 */
export function testIncoming(from) {
    emulateMessage({"broadcast":"call","action":"broadcast","number":from,"state":"ringing"}, 2000);
}

export function emulateMessage(msg, timeout){
    setTimeout(function(){
        //handleMessage(msg)
    }, timeout);
}


export const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

export function isAdblockDetected () {
    let fakeAd = document.createElement("div");
    fakeAd.className =
        "textads banner-ads banner_ads ad-unit ad-zone ad-space adsbox"

    fakeAd.style.height = "1px"

    document.body.appendChild(fakeAd)

    let x_width = fakeAd.offsetHeight;

    document.body.removeChild(fakeAd)

    return !x_width || x_width <= 0
}
export function showMessage(title, message, button, handler = null) {
    return toast(message ? (title + " - " + message) : title);
}
export function showLongToast(message) {
    return toast(message, {duration: 3000});
}
export function cancelMessage(id) {
    if (!id) {
        toast.dismiss();
    } else {
        toast.dismiss(id);
    }
}


export const languages = [
    {
        id: "en-US",
        name: "English (US)"
    },
    {
        id: "en-GB",
        name: "English (UK)"
    },
    {
        id: "pt-PT",
        name: "Portuguese (PT)"
    },
    {
        id: "pt-BR",
        name: "Portuguese (BR)"
    },
    {
        id: "es-ES",
        name: "Spanish (ES)"
    },
    {
        id: "fr-FR",
        name: "French (FR)"
    },
];

export function getRemoteConfigString(key, def) {
    return getValue(rc, key)?.asString() || def;
}
export function getRemoteConfigBoolean(key, def) {
    return getValue(rc, key)?.asBoolean() || def;
}
export function getRemoteConfigNumber(key, def) {
    return getValue(rc, key)?.asNumber() || def;
}
